import React from "react";
import "./Object.css";

export const About = () => {
  return (
    <div className="bg-transparent">
      <div className="py-1 ">
        <div className="container px-5 my-5">
          <div className="row gx-5 justify-content-center">
            <div className="col-lg-10 col-xl-7">
              <div className="text-center">
                <div className="fs-4 mb-5 text-center">
                  <h2 className="fw-bolder text-white mb-4" style={{ textShadow: "0 2px 4px rgba(0,0,0,0.5)", letterSpacing: "0.02em" }}>About TheEmbryo</h2>
                  <p className="text-white text-justify mx-auto" style={{ fontSize: "1.1rem", lineHeight: "1.8", maxWidth: "800px", color: "#e2e8f0" }}>
                    Research and development (R&D) include activities that
                    companies undertake to innovate and introduce new products
                    and services. It is often the first stage in the development
                    process. The goal is typically to take new products and
                    services to market and add to the company’s bottom line.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
